import React, {useState} from "react"
import { Btn, FormTextarea, Modal } from "./";
import {useCore} from "../hooks";
import {CustomCheckoutOrder} from "../store/core/reducer.ts";
import {toast} from "react-toastify";

type Props = {
  order: CustomCheckoutOrder
  onUpdate: () => void
}
export const ModalNotesOnExistingOrder: React.FC<Props> = ({ order, onUpdate }) => {
  const { core } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [note, setNote] = useState<string>('')
  const [privateNote, setPrivateNote] = useState<string>('')

  const openModal = () => {
    setNote(order?.note || '')
    setPrivateNote(order?.privateNote || '')
    setIsVisible(true)
  }

  const closeModal = () => {
    setNote('')
    setPrivateNote('')
    setIsVisible(false)
  }

  const updateOrderNotes = async () => {
    const nextOrder = {...order}
    nextOrder.note = note
    nextOrder.privateNote = privateNote
    // todo fragments. keep it simple for now, so fck zeus
    const res = await core.services.order.updateOrderNotes(nextOrder)
    console.log(res)
    toast.success('Poznámky byly upraveny')
    onUpdate()
    closeModal()
  }

  return (
    <Modal
      modalOpenBtn={<Btn className="btn-base-100" icon={'far fa-edit'} children={'Upravit poznámky'} onClick={openModal} />}
      isVisible={isVisible}
      modalTitle={'Poznámky'}
      modalWidth={'sm'}
      onClose={closeModal}
      content={
        <div>
          <FormTextarea label={'Poznámka'} value={note} onChange={e => setNote(e)} />
          <FormTextarea label={'Skrytá poznámka'} value={privateNote} onChange={e => setPrivateNote(e)} />
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <Btn className="btn-base-100" icon={'fa-times'} children={'Zrušit'} onClick={() => setIsVisible(false)}/>
          <Btn className="btn-primary" icon={'fa-check'} children={'Upravit poznámky'} onClick={updateOrderNotes}/>
        </div>
      }
    />
  )
}
